// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Linkedin: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
            <path
                d="M22.7500008,0 L1.74453175,0 C0.782031417,0 0,0.79296875 0,1.76640558 L0,22.7335944 C0,23.7070312 0.782031417,24.5 1.74453175,24.5 L22.7500008,24.5 C23.7125012,24.5 24.5,23.7070312 24.5,22.7335944 L24.5,1.76640558 C24.5,0.79296875 23.7125012,0 22.7500008,0 Z M7.404688,21 L3.77343833,21 L3.77343833,9.30781233 L7.41015708,9.30781233 L7.41015708,21 L7.404688,21 Z M5.58906317,7.7109375 C4.42421925,7.7109375 3.48359442,6.76484442 3.48359442,5.60546875 C3.48359442,4.44609308 4.42422009,3.5 5.589064,3.5 C6.74843884,3.5 7.69453275,4.44609308 7.69453275,5.60546875 C7.69453275,6.77031183 6.75390792,7.7109375 5.589064,7.7109375 L5.58906317,7.7109375 Z M21.0164064,21 L17.3851568,21 L17.3851568,15.3125 C17.3851568,13.9562507 17.357813,12.2117189 15.498438,12.2117189 C13.6062502,12.2117189 13.3164071,13.6882806 13.3164071,15.2140632 L13.3164071,21 L9.68515742,21 L9.68515742,9.30781233 L13.168751,9.30781233 L13.168751,10.9046872 L13.2179694,10.9046872 C13.7046878,9.985937 14.8914064,9.01796842 16.6578137,9.01796842 C20.3328127,9.01796842 21.0164064,11.4406248 21.0164064,14.5906243 L21.0164064,21 Z"
                transform="translate(0 .25)"
            />
        </svg>
    );
};

export default React.memo(Linkedin);
